import Entity from "./Entity";
class Guarantee {
    guarantors;
    constructor(response) {
        this.guarantors = response.guarantors?.map(g => new Entity(g));
    }
}
export default Guarantee;
